import { sendRequest } from '../AxiosRequest';
import { axiosPatch } from '../AxiosApi';
import { UpdateVersionType } from '@/types';

export const updateVersionDetail = async (updateVersionType: UpdateVersionType) => {
  const payload = {
    path: '/version',
    body: { ...updateVersionType },
  };
  return sendRequest(payload, 'updateVersionDetail', axiosPatch);
};
